<template>
  <div>
    <div>
      <el-form :inline="true" style="line-height: 40px;" :model="postForm" :rules="rules" ref="postForm">

        <el-form-item label="标题">
          <el-input size="mini" v-model="saveFrom.name">
          </el-input>
        </el-form-item>
        <el-form-item label="打印id">
          <el-input size="mini" v-model="saveFrom.id ">
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="表单id">
          <el-input size="mini" v-model="formid ">
          </el-input>
        </el-form-item> -->
        <el-form-item label="描述">
          <el-input size="mini" v-model="saveFrom.description ">
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button v-loading="loading" size="mini" @click="submitForm">保存</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button v-loading="loading" size="mini" @click="Newprint()">预览</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button v-loading="loading" size="mini" @click="Newexport()">导出JSON文件 </el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button v-loading="loading" size="mini" @click="Neweximport()">导入JSON文件 </el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button v-loading="loading" size="mini" @click="editData()">编辑打印数据 </el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button v-loading="loading" size="mini" @click="edit()">编辑模板数据 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <Designer :template="template" :authKey="authKey" :printData="printData" :headerTitle="headerTitle"
      @onDesigned="onDesigned">
      <div class="header" slot="header">
        <div class="header">

        </div>
      </div>
    </Designer>
  </div>
</template>

<script>
  import * as sysRpts from '@/views/dlsvprint/api/sysRpts'
  import "sv-print/dist/style.css"; // 一般在入口文件(index/main)添加
  import Bus from "@/utils/EventBus";
  // import { Designer } from "@sv-print/vue";
  import * as forms from '@/api/forms'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    // components: { Designer, forms },
    props: {
      printForm: {
        type: Array

      },
      fromid: {
        type: String
      }
    },
    data() {
      return {
        template: {},
        authKey: "53616C7465645F5F7BCCFBCC5D7FCC45BBD985DBB2D854604DACE0976DD5A5C0C2BC48847291A1E7D23B658CBBA58EBD40461AE2D6CEA435B92DDB5F4857AD08",
        printData: { name: "德莱套打控件" },
        headerTitle: "德莱套打控件",
        postForm: {},
        priterFrom: {},
        designerUtils: {},
        name: '',
        rptnam: '',
        saveFrom: {
          rptname: '',
          id: '',
        },
        formid:'',

      };
    },
    created() {

      this.saveFrom = this.printForm

      // console.log('this.saveFrom',this.saveFrom);
      let vdata = JSON.parse(this.saveFrom.entity) || {}

      if (this.saveFrom.tableDT) {
        let datatable = JSON.parse(this.saveFrom.tableDT)
        vdata.printData = datatable
        //打印数据
        this.printData = vdata.printData
      }
      //打印模板
      this.template = vdata.template


    },
    methods: {
      onDesigned(e) {
        // 分别是 hiprint模块、打印模板对象、设计器工具类
        const { hiprint, printTemplate, designerUtils } = e.detail;
        console.log('designerUtils',designerUtils)
        this.designerUtils = designerUtils
        // 暴露编辑函数供独立版 hiprint 的 textarea click 调用
        window.__svprintEditFunction = (optItem, printElement, event) => {
          designerUtils.editFunction(optItem, printElement, event)
        }

        if (this.printForm.type == 1) {
          this.Newprint()
        }
      },
      submitForm() {
        // 显示组件内的 预览窗口
        // console.log(this.designerUtils.printData);
        let saveobj = {}
        saveobj.printData = this.designerUtils.printData
        saveobj.template = this.designerUtils.printTemplate.getJson()
        console.log(saveobj);
        this.saveFrom.rptid = this.saveFrom.id
        
        this.saveFrom.entity = JSON.stringify(saveobj)
        // this.saveFrom.formId='this.formid'
        sysRpts.update(this.saveFrom).then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.$message.success('保存成功')
            setTimeout(() => {
              // Bus.$emit("loading");
              window.close()
           
            }, 1000);


          }
        })


      },
      Newexport() {
        // 导出模板json文件
        this.designerUtils.export();
      },

      Newprint() {
        debugger
        console.log(  this.designerUtils)
        // 显示组件内的 预览窗口
        this.designerUtils.preview.show();
      },
      NewHtml() {
        // 获取设计器预览 html
        this.designerUtils.printTemplate.getHtml();
        // console.log(this.designerUtils.printTemplate.getHtml());
      },
      editData() {
        this.designerUtils.editData();
      },
      edit() {
        this.designerUtils.edit();
      },
      Neweximport() {
        // 导入模板json文件
        this.designerUtils.import();
      },
      // sc(){
      //  console.log(JSON.parse(window.localStorage.getItem('sv-print-preferences'))['default-template']);
      //   this.designerUtils.newPrintTemplate({});
      // }


    },
  };
</script>
<style lang="less" scoped>
  :deep .el-form-item {
    margin-bottom: 0px !important;
  }
</style>